export const routes = [
  { displayName: "Main", address: "" },
  { displayName: "About", address: "about" },
  { displayName: "Privacy", address: "privacy" },
  { displayName: "Terms of Sevice", address: "tos" },
  { displayName: "Legal", address: "legal" },
  { displayName: "Contact", address: "contact" },
];
